import { render, staticRenderFns } from "./diff_discussions.vue?vue&type=template&id=ea995d22&"
import script from "./diff_discussions.vue?vue&type=script&lang=js&"
export * from "./diff_discussions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diff_discussions.vue"
export default component.exports